export const Statistics_API = {
  async post(url, proxy, criterias) {
    const _token = localStorage.getItem("_token");
    const res = await fetch(`${proxy}${url}`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: _token,
      },
      body: JSON.stringify({ criterias }),
    });
    return res.json();
  },
};
export async function fetchThongKeXuatNhapKho({ request }) {
  const API_URL = window.REACT_APP_API_URL;
  try {
    const res = await fetch(API_URL + "/api/stats/Kho/SoLot", {
      method: "POST",
      headers: {
        Authorization: localStorage.getItem("_token"),
      },
    });

    if (!res.ok) {
      throw new Error("Failed to fetch");
    }

    return await res.json();
  } catch (err) {
    console.error("Loader error:", err);
    // Optional: redirect or return fallback
    throw err;
  }
}
